<div class="bg-white p-5">
  <div
    class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6 border-b border-gray-300 pb-5"
  >
    <h1 class="text-xl font-bold text-dc-navy">
      Venue Bookings
    </h1>

    <div class="flex gap-4">
      <app-button
        classesName="btn-edge-cut"
        [label]="'BUTTONS.BOOK_VENUE' | translate"
        (onBtnClick)="applyForService()"
      >
      </app-button>
    </div>
  </div>
  <form
    [formGroup]="filterForm"
    class="flex flex-wrap gap-4 mb-6 border-b border-gray-300"
  >
    <div class="field-control min-w-3xs">
      <app-option-field
        [label]="'MY_APPS.FILTER.STATUS' | translate"
        [options]="statuses"
        [control]="filterForm.get('status')"
      >
      </app-option-field>
    </div>

    <div class="ms-auto w-full sm:w-72">
      <div
        class="flex items-center border border-gray-300 overflow-hidden mt-5"
      >
        <input
          type="text"
          [placeholder]="'SEARCH' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          (input)="(false)"
        />
        <button type="button" class="px-4 text-dc-navy">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form>

  <app-table
    [tableHeadings]="[
      'MY_APPS.COL.APP' | translate,
      'MY_APPS.COL.SERVICE' | translate,
      'MY_APPS.COL.MEMBER' | translate,
      'MY_APPS.COL.INVOICE' | translate,
      'MY_APPS.COL.DATE' | translate,
      'MY_APPS.COL.STATUS' | translate,
      'MY_APPS.COL.JOB' | translate
    ]"
    [dataKeys]="[
      'applicationId',
      'serviceLabel',
      'membershipLabel',
      'invoice',
      'date',
      'status',
      'jobNumber'
    ]"
    [listData]="filteredRows"
    [showActions]="true"
    [showPagination]="true"
    [showActionView]="true"
    (onView)="viewApp($event)"
    (onMore)="moreActions($event)"
  >
  </app-table>
</div>
